import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    promotions: [],
    currentPromotion: {},
    applies: [],
    discountTypes: [],
    // Produits sélectionnés depuis un autre écran (ex: "Produits stagnants"
    // d'une boutique) en attente d'être injectés dans la promotion en cours
    // de création — voir Shop/StagnantProducts.vue, Promotion/Index.vue et
    // Promotion/Detail.vue.
    pendingProducts: [],
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
